import React from 'react'
import { Breadcrumb } from '../../../components'
import { useInternationalization } from '../../../features/i18n'

const PageHeader = ({ eventId }) => {
  const { translate } = useInternationalization()

  const routes = [
    {
      name: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard'
    },
    {
      name: translate('EVENT', 'our'),
      route: '/dashboard/events'
    },
    {
      name: translate('EVENT', 'details'),
      route: `/dashboard/events/update/${eventId}`
    },
    {
      name: translate('EVENT', 'guest_list'),
      route: `/dashboard/events/${eventId}/guest-list`
    }
  ]

  return <>
    <div className="hidden lg:block">
      <Breadcrumb routes={routes}/>
    </div>
    <div className="flex mt-8 mb-5 lg:mt-2 lg:mb-2">
      <h1 className="text-lg lg:text-4xl font-primary font-bold mr-2 leading-tight lg:leading-none">
        {translate('EVENT', 'guest_detail')}
      </h1>
    </div>
  </>
}

export default PageHeader
